module.exports = __webpack_public_path__ + "img/1x.86464e9.jpg";